//
// Module for the Batch Detail screen
//

rs.module("ui/content/jobs/insuranceimport/batchdetail",

    ["controls/navigation/tabstrip"],

    function (tabModule) {
        function initialize(constants, commentsControl) {
            // When a comment updates, update the text in the tabs control
            commentsControl.onNoteSaved(function (commentCount) {
                var tabText = constants.commentsTabText;
                if (commentCount > 0) {
                    tabText = tabText + ' (' + commentCount + ')';
                }
                tabModule.setTabText(constants.commentsTabKey, tabText);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);